export function initNavigation() {
  // Czekaj aż GenerateBlocks menu się załaduje
  setTimeout(() => {
    const navigation = document.querySelector("#menu-menu-glowne");
    if (!navigation) return;

    const overlayBlock = document.querySelector(".overlay-block");

    // Funkcja do zarządzania overlay
    function toggleOverlay() {
      const openSubmenus = navigation.querySelectorAll(".gb-sub-menu--open");
      if (overlayBlock) {
        if (openSubmenus.length > 0) {
          overlayBlock.classList.add("active");
        } else {
          overlayBlock.classList.remove("active");
        }
      }
    }

    // Znajdź wszystkie submenu
    const submenus = navigation.querySelectorAll(".sub-menu");

    submenus.forEach((submenu) => {
      const parentItem = submenu.closest(".menu-item");
      const parentLink = parentItem.querySelector("a");
      const parentTitle = parentLink.textContent.trim();

      // Dodaj nagłówek z nazwą rodzica jako li
      const header = document.createElement("li");
      header.className = "menu-item submenu-header";
      header.innerHTML = `<a href="#" class="submenu-title gb-menu-link">${parentTitle}</a>`;
      submenu.insertBefore(header, submenu.firstChild);

      // Dodaj przycisk cofnij
      const backButton = document.createElement("li");
      backButton.className = "menu-item back-button";
      backButton.innerHTML = `<a href="#" class="back-link gb-menu-link">Cofnij</a>`;
      submenu.appendChild(backButton);

      // Obsługa kliknięcia w nagłówek rodzica
      header.addEventListener("click", function (e) {
        e.preventDefault();
        closeGenerateBlocksSubmenu(parentItem);
        toggleOverlay();
      });

      // Obsługa kliknięcia w przycisk cofnij
      backButton.addEventListener("click", function (e) {
        e.preventDefault();
        closeGenerateBlocksSubmenu(parentItem);
        toggleOverlay();
      });
    });

    function closeGenerateBlocksSubmenu(menuItem) {
      const navigation = menuItem.closest(".gb-navigation");
      const parentLink = menuItem.querySelector("a");
      const submenuToggle = menuItem.querySelector(".gb-submenu-toggle");

      // Użyj logiki z GenerateBlocks
      menuItem.classList.remove("current-menu-item");
      menuItem.classList.remove("gb-sub-menu--open");
      menuItem.setAttribute("aria-current", "false");

      if (parentLink && parentLink.hasAttribute("aria-expanded")) {
        parentLink.setAttribute("aria-expanded", "false");
      }

      if (submenuToggle && submenuToggle.hasAttribute("aria-expanded")) {
        submenuToggle.setAttribute("aria-expanded", "false");
      }

      // Pokaż rodzica jeśli to submenu trzeciego poziomu
      const grandparent = menuItem.closest(".sub-menu")?.closest(".menu-item");
      if (grandparent && !grandparent.classList.contains("gb-sub-menu--open")) {
        grandparent.classList.add("current-menu-item");
        grandparent.classList.add("gb-sub-menu--open");

        const grandparentLink = grandparent.querySelector("a");
        const grandparentToggle =
          grandparent.querySelector(".gb-submenu-toggle");

        if (grandparentLink && grandparentLink.hasAttribute("aria-expanded")) {
          grandparentLink.setAttribute("aria-expanded", "true");
        }

        if (
          grandparentToggle &&
          grandparentToggle.hasAttribute("aria-expanded")
        ) {
          grandparentToggle.setAttribute("aria-expanded", "true");
        }
      }
    }

    // Nasłuchiwanie zmian w DOM dla submenu
    const observer = new MutationObserver(() => {
      toggleOverlay();
    });

    // Obserwuj zmiany klas na elementach menu
    const menuItems = navigation.querySelectorAll(".menu-item");
    menuItems.forEach((item) => {
      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }, 100);
}
